import SettingTimesheetCreateRole from "../components/SettingTimesheetCreateRole";
import SettingTimesheetEditRole from "../components/SettingTimesheetEditRole";
import useStpTimeSheetCreateRole from "../hooks/useStpTimeSheetCreateRole";

const SettingTimesheetEditRolePage = () => {
    const props = useStpTimeSheetCreateRole()
    return (
        <SettingTimesheetEditRole {...props } />
    )
}

export default SettingTimesheetEditRolePage;